import { PaginationTable as CreditasPagination } from '@creditas/pagination'
import { css, styled } from '@creditas/stylitas'
import { compose, withDefaultProps, withForwardRef } from '@creditas/utils'
import { SpacingSection } from 'homepage/presentation/components/Home.styles'
import { func, number, string } from 'prop-types'
import React from 'react'
import {
  alignArrowsRight,
  bgTransparent,
  hideDropDown,
  pagination,
} from './pagination.styles'

const PaginationStyled = styled(CreditasPagination)(
  ({ isOnLastPage, isOnFirstPage, theme }) => css`
    margin-top: 48px;
    margin-bottom: 60px;
    grid-template-columns: 160px auto;
    ${alignArrowsRight};
    ${hideDropDown};
    & > div > div {
      ${bgTransparent};
    }
    ${bgTransparent};
    ${pagination({ isOnFirstPage, isOnLastPage, theme })}
  `,
)

const propTypes = {
  currentPage: number,
  totalItems: number,
  limit: number,
  onChangePage: func,
  totalVisibleItems: number,
  testId: string,
}

const defaultProps = {
  currentPage: 1,
  totalVisibleItems: 1,
}

const enhancer = compose(
  withForwardRef,
  withDefaultProps(propTypes, defaultProps),
)

const element = enhancer(function Pagination(props) {
  const {
    withRef,
    totalItems,
    currentPage,
    limit,
    onChangePage,
    totalVisibleItems,
    testId,
    ...other
  } = props
  const totalPages = Math.ceil(totalItems / limit)
  const isOnFirstPage = currentPage === 1
  const isOnLastPage = currentPage === totalPages
  const interval = limit * currentPage - limit + 1
  const maxItemsOnPage = isOnLastPage ? totalItems : limit * currentPage

  return (
    <SpacingSection>
      <PaginationStyled
        ref={withRef}
        data-testid={testId}
        isOnFirstPage={isOnFirstPage}
        isOnLastPage={isOnLastPage}
        current={currentPage}
        total={totalPages}
        maxPages={totalVisibleItems}
        onChangePage={newPageNumber => onChangePage(newPageNumber, limit)}
        translations={{
          overview: () => `${interval}-${maxItemsOnPage} de ${totalItems}`,
          select: option => `Mostrar ${option}`,
          ariaCurrentPage: current => `página atual ${current}`,
          ariaFirstPage: () => 'primeira página',
          ariaPreviousPage: () => 'página anterior',
          ariaNextPage: () => 'próxima página',
          ariaLastPage: () => 'última página',
          ariaPage: page => `página ${page}`,
        }}
        {...other}
      />
    </SpacingSection>
  )
})

export { element as Pagination }
